import { useQuery } from '@apollo/client';
import FETCH_ORGANIZATIONS from 'src/graphql/querys/fetchOrganizations';

const useOrganizations = () => {
  const { data = {}, loading, refetch } = useQuery(FETCH_ORGANIZATIONS);
  const { organizations = null } = data;
  return { organizations: organizations ? organizations : [], loading, refetch };
};

export default useOrganizations;
